<template>
  <v-app>
    <v-content>
      <v-container>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="no-print my-2"
        >
          <v-btn
            exact
            text
            :to="{
              name: prevRoute !== null ? prevRoute : 'StatisticsIndex',
              params: prevRouteParams
            }"
          >
            <v-icon small left>fa-chevron-left</v-icon>Retour
          </v-btn>
          <v-btn icon text @click="printDialog">
            <v-icon>fa-print</v-icon>
          </v-btn>
        </v-row>
        <router-view></router-view>
      </v-container>
    </v-content>
    <ProgressOverlay></ProgressOverlay>
  </v-app>
</template>

<script>
import { ProgressOverlay } from "@/modules/Shared";
export default {
  name: "ViewerLayout",
  components: {
    ProgressOverlay
  },
  data() {
    return {
      prevRoute: "StatisticsIndex",
      prevRouteParams: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.prevRoute = from.name;
      vm.prevRouteParams = from.params;
      if (vm.prevRoute === "PreparationSlipEditor") {
        vm.prevRoute = "StatisticsIndex";
        vm.prevRouteParams = {};
      } else if (vm.prevRoute === "DeliverySlipCreator") {
        vm.prevRoute = "StatisticsIndex";
        vm.prevRouteParams = {};
      }
    });
  },
  methods: {
    printDialog() {
      window.print();
    }
  }
};
</script>

<style></style>
